import React from 'react';
import { EventedModal, ModalNames } from '|/app/modals';
import styles from './lock-timer-modal.module.css';

interface LockTimerModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LockTimerModal: React.FC<LockTimerModalProps> = ({ isOpen, onClose }) => {
  return (
    <EventedModal
      isOpen={isOpen}
      analyticsId={ModalNames.LockTimer}
      onClose={onClose}
      mobileStyle="inset"
      desktopWidth="480px"
      closeIcon={true}
      divLine={false}
      aria-labelledby="lock-timer-modal-title"
    >
      <div className={styles.modalContent}>
        <h2 id="lock-timer-modal-title" className={styles.title}>
          Vehicle is temporarily reserved
        </h2>
        <p className={styles.description}>
          This vehicle is being held for you while you provide purchase details. When time runs out,
          the vehicle will unlock and could be purchased by someone else.
        </p>
      </div>
    </EventedModal>
  );
};

export default LockTimerModal;
